import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const middleware = [thunk];

// Create redux store
const store = createStore(
  rootReducer,
  applyMiddleware(
    ...middleware
  ),
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js